/**
 *
 * Branch Details
 *
 */
import { RootState } from 'controller/types';

import { useBranchSetupSlice } from 'features/BranchSetup/slice';
import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';

import { BranchDetailsForm } from 'features/BranchSetup/components/DesktopComponents/Forms/BranchDetailsForm';
import {
  Branch,
} from 'core/utils/types/modules/org';
import { Spinner } from 'core/components/Spinner';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';

interface Props {
  onNext?: () => void
}

export const BranchDetails = memo((props: Props) => {
  const dispatch = useDispatch();
  const { actions } = useBranchSetupSlice();
  const state:any = useSelector((state: RootState) => state.branchSetup);

  const authData = useAuth();

  React.useEffect(() => {
    return () => {
      dispatch(actions.clearBranchData());
    };
  }, []);

  React.useEffect(() => {
    if (authData?.BRANCH_ID){
    dispatch(
      actions.fetchBranchSetupOneStart({
        ID: authData?.BRANCH_ID,
        URL: 'branch',
      }),
    )}
  }, [
    authData?.BRANCH_ID,
    authData?.SELECTED_ACADEMIC_YEAR?.ACADEMIC_YEAR_ID,
  ]);

  return !(state?.branchData) ? (
    <div className="w-full h-[40vh] flex justify-center items-center">
      <Spinner width="5vw" />
    </div>
  ) : (
    <Div className="w-full min-h-max bg-white rounded-xl shadow-xl px-[2vw] py-[1.5vw]">
       <BranchDetailsForm
        action="update"
        values={state?.branchData as Branch}
        onNext={props?.onNext}
      />
    </Div>
  );
});

const Div = styled.div``;
